// extracted by mini-css-extract-plugin
export default {"leftStickyCell":"PlanAccuracyDetail_leftStickyCell__8yOr-","cell":"PlanAccuracyDetail_cell__2XGVn"};